import React,{Component} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import moment from 'moment';
import {isDateInput} from '../../../../utils/Validators';
import { showError } from '../../../../actions/uiActions';
import { connect } from 'react-redux';

class DateEdit extends Component {
    constructor(props) {
        super(props);
        this.state={
            date: moment(props.date, "MM/DD/YYYY").format("YYYY-MM-DD"),
            employerName: props.employer?.employer_name || ''
        }
    }
    submit = () => {
        if (this.props.isTLFForm && !this.state.employerName) {
            this.props.showError(
                'Please enter the name of the employer/school'
            );
            return
        }
        this.props.onSubmit(this.state.date, this.state.employerName);
    }
    render() {
        return <Dialog size={"sm"} onClose={this.props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" open={true}
        >
        <DialogTitle id="alert-dialog-title">Edit Date</DialogTitle>
        <DialogContent>
            <div className="row" style={{minWidth:"500px"}}>
                <div className="col-8 offset-2">
                    <div className="form-group">
                        <label>Date:</label>
                        <input onChange={e=>this.setState({date:e.target.value})} value={this.state.date} type="date" className="form-control" />
                    </div>
                </div>
                {this.props.isTLFForm && (
                    <div className="col-8 offset-2">
                        <div className='form-group'>
                            <label>Employer name:</label>
                            <input
                                type='text'
                                className='form-control'
                                onChange={e => this.setState({ employerName: e.target.value })}
                                value={this.state.employerName}
                                name='employerName'
                                placeholder='Enter employer/school name'
                            />
                        </div>
                    </div>
                )}
            </div>
                
        { this.props.moreText && <div className="row">
            <div className="col-8 offset-2">
                {this.props.moreText}
            </div>
        </div> }
        </DialogContent>
        <DialogActions>
          <Button disabled={!isDateInput(this.state.date)} variant="outlined" onClick={this.submit} color="primary" autoFocus>
            Set Event Date
          </Button>
          <Button onClick={this.props.onClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
        </Dialog>;
    }
};

export default connect(null, {
    showError,
})(DateEdit);
